import firebase from '../../firebase/compat'
import { db } from '../../firebase/config'
import { client } from '../../hooks/Client'
import notDeleted from '../notDeleted'

/**
 * Haalt aanwezigheidsrapporten op voor een vrij gekozen periode.
 *
 * De kaart op het dashboard leest per maand; een export mag over een langere
 * periode gaan, dus dit haalt eenmalig op wat de gebruiker vraagt. Zonder
 * begin- of einddatum vervalt die grens.
 *
 * Dit is een directe read buiten de hooks om, dus de tenantfilter en het
 * soft-delete-filter staan hier met de hand.
 * AI-CONTEXT: See docs/pitfalls.md#database-missing-compagnyid-on-fresh-fetch
 *
 * @param {Date|null} startDate
 * @param {Date|null} endDate
 * @returns {Promise<Array<object>>} De gevonden rapporten
 */
const fetchPresenceReportsInRange = async (startDate, endDate) => {
    let query = db.collection('PersonaPresenceReports').where('CompagnyID', '==', client)

    if (startDate) {
        const from = new Date(startDate)
        from.setHours(0, 0, 0, 0)
        query = query.where('Timestamp', '>=', firebase.firestore.Timestamp.fromDate(from))
    }

    if (endDate) {
        const until = new Date(endDate)
        until.setHours(23, 59, 59, 999)
        query = query.where('Timestamp', '<=', firebase.firestore.Timestamp.fromDate(until))
    }

    const snapshot = await query.get()

    return snapshot.docs
        .map((doc) => ({ ...doc.data(), id: doc.id }))
        .filter(notDeleted)
}

export default fetchPresenceReportsInRange
